export async function importResource(_locale: string, _ns: string): Promise<{ [key: string]: string }> {
	return {}
}
export default importResource
